import React from 'react';
import { Icon, ListItem, ListItemIcon, ListItemText } from "@material-ui/core"
import { Person, Contacts, Group, LocationOn, Grain, AccountBalanceWallet, Assessment } from "@material-ui/icons"
import { NavLink, useLocation, Link } from 'react-router-dom'
import { Strings } from '../../../assets/res/en'
function  useFlyoutMenus(classes) {
    const { pathname } = useLocation()
    const {
        MENU_USER_TITLE,
        MENU_PROFILES_TITLE,
        MENU_GROUPS_TITLE,
        MENU_LOCATIONS_TITLE,
        MENU_PROGRAMS_TITLE,
        MENU_CARDHOLDERS_TITLE,
        MENU_PROMOTIONS_TITLE,
        MENU_REPORTS_TITLE
    } = Strings
    const menus = [
        {
            title: MENU_USER_TITLE,
            icon: <Person />,
            linkTo: "/user"
        },
        {
            title: MENU_PROFILES_TITLE,
            icon: <Contacts />,
            linkTo: "/profiles"
        },
        {
            title: MENU_GROUPS_TITLE,
            icon: <Group />,
            linkTo: "/groups"
        },
        {
            title: MENU_LOCATIONS_TITLE,
            icon: <LocationOn />,
            linkTo: "/locations"
        },
        {
            title: MENU_PROGRAMS_TITLE,
            icon: <Grain />,
            linkTo: "/programs"
        },
        {
            title: MENU_CARDHOLDERS_TITLE,
            icon: <AccountBalanceWallet />,
            linkTo: "/cardholders"
        },
        {
            title: MENU_PROMOTIONS_TITLE,
            icon: <svg viewBox="0 0 24 24" className="MuiSvgIcon-root"><path d="M0 0h24v24H0z" fill="none" /><path d="M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z" /></svg>,
            linkTo: "/promotions"
        },
        {
            title: MENU_REPORTS_TITLE,
            icon: <Assessment />,
            linkTo: "/reports"
        },
        {
            title: 'Mini CMS',
            icon: <Icon>casino</Icon>,
            linkTo: "/cms"
        }
    ].map((item, index) => (
        item.isExternal === true ?
            <a key={item.title} href={item.linkTo} className={classes.menuLink}>
                <ListItem
                    button
                    alignItems="center"
                    classes={{ root: classes.paddedMenu, button: classes.menuList, selected: classes.selected }}
                    selected={pathname === item.linkTo || (pathname === "/" && index === 0) || (`/${pathname.split('/')[1]}` === item.linkTo)}>
                    <ListItemIcon className={classes.menuIcon}>
                        {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.title} classes={{ primary: classes.smallFont }} />
                </ListItem>
            </a>
            :
            <NavLink key={item.title} to={item.linkTo} className={classes.menuLink}>
                <ListItem
                    button
                    alignItems="center"
                    classes={{ root: classes.paddedMenu, button: classes.menuList, selected: classes.selected }}
                    selected={pathname === item.linkTo || (pathname === "/" && index === 0) || (`/${pathname.split('/')[1]}` === item.linkTo)}>
                    <ListItemIcon className={classes.menuIcon}>
                        {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.title} classes={{ primary: classes.smallFont }} />
                </ListItem>
            </NavLink>
    ))
    return [menus]
}

export default useFlyoutMenus;